/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

type RadioContextValue = {
  index: number;
};

const RadioItemContext = createContext<RadioContextValue>({} as RadioContextValue);
const useRadioItemContext = () => useContext(RadioItemContext);

export { RadioItemContext, useRadioItemContext };
